import get from 'lodash.get';

import { PERIOD } from '../../constants/enrollment';
import { APP_GROUP_BY_APPLICATION_ID } from '../../constants/applications';

const getAvailableBenchmarkPeriods = (applicationGroup, fourthPeriodAvailability) => {
    const isFourthPeriodEnabled = get(fourthPeriodAvailability, applicationGroup, false);
    if (isFourthPeriodEnabled) {
        return [PERIOD.BOY, PERIOD.MOY, PERIOD.EOY, PERIOD.SUMMER];
    }
    return [PERIOD.BOY, PERIOD.MOY, PERIOD.EOY];
};

export const getAllAvailablePeriods = (applicationGroup, fourthPeriodAvailability) => [
    ...getAvailableBenchmarkPeriods(applicationGroup, fourthPeriodAvailability),
    PERIOD.PM,
];

export const getAllAvailablePeriodsForApplication = (application, fourthPeriodAvailability) =>
    getAllAvailablePeriods(APP_GROUP_BY_APPLICATION_ID[application], fourthPeriodAvailability);

export default getAvailableBenchmarkPeriods;
